/* eslint-disable camelcase */
export const self_reject = {
  'your-answer-has-been-received': 'Спасибо! Твой ответ записан',
  'do-you-want-reject-vacancy': 'Хочешь отказаться от вакансии?',
  'choose-reject-reason': 'Выбери причину отказа',
  'reject-reason': 'Причина отказа',
  'to-reject': 'Отказаться',
};
